import { breakpoints, Columns, Column } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import InfoBox from './InfoBox';

const columnWidth = { [breakpoints._0]: '6/6', [breakpoints._768]: '2/6' } as const;

const InfoBoxContent = () => {
  const { t } = useTranslation();

  return (
    <Columns
      aria-label={t('ScreenReader.StartPage.InfoBoxContentLabel')}
      as="section"
      collapseBelow={breakpoints._768}
      spacing={24}
    >
      <Column width={columnWidth}>
        <InfoBox
          link={t('IbeClient.InfoBox1.Link')}
          linkLabel={t('IbeClient.InfoBox1.Link.Label')}
          text={t('IbeClient.InfoBox1.Text')}
          title={t('IbeClient.InfoBox1.Header')}
        />
      </Column>
      <Column width={columnWidth}>
        <InfoBox
          link={t('IbeClient.InfoBox2.Link')}
          linkLabel={t('IbeClient.InfoBox2.Link.Label')}
          text={t('IbeClient.InfoBox2.Text')}
          title={t('IbeClient.InfoBox2.Header')}
        />
      </Column>
      <Column width={columnWidth}>
        <InfoBox
          link={t('IbeClient.InfoBox3.Link')}
          linkLabel={t('IbeClient.InfoBox3.Link.Label')}
          text={t('IbeClient.InfoBox3.Text')}
          title={t('IbeClient.InfoBox3.Header')}
        />
      </Column>
    </Columns>
  );
};

export default InfoBoxContent;
